/** Panel background deselects completed selections, never an unfinished building. */
export const shouldDeselectBuildingFromLeftPanel = ({
  clickedPanelBackground,
  hasBuildingCandidate,
}: {
  clickedPanelBackground: boolean;
  hasBuildingCandidate: boolean;
}): boolean => clickedPanelBackground && !hasBuildingCandidate;
